/** Разрешить только внутренние относительные пути (защита от open redirect). */
export const sanitizeReturnUrl = (raw: string | null, _basename: string): string | null => {
  if (!raw || typeof raw !== "string") return null
  const trimmed = raw.trim()
  if (!trimmed.startsWith("/")) return null
  if (trimmed.startsWith("//")) return null
  if (trimmed.includes("://")) return null
  if (trimmed.toLowerCase().includes("javascript:")) return null
  return trimmed
}
